export const STORE_TYPES = { small: 'small', big: 'big', av: 'av' };
export const INIT_STAGES = { RUN: 'RUN', DONE: 'DONE' };
export const ITEM_STATUSES = { LOADING: 'LOADING', HANDLED_LOADING: 'HANDLED_LOADING' };
